module.exports = __webpack_public_path__ + "img/1F3F4-E0075-E0073-E0074-E0078-E007F.02cd7638.svg";